module.exports = __webpack_public_path__ + "static/media/proceso_producción.c162d20b.jpg";